import { ApiResponseType } from '@/api/type/commonTypes';
import { GetAllServiceResponse } from '../type/types';
import { api } from '../axiosInstance';

// 서비스 전체 옵션 조회
export const getAllService = async () => {
  const res = await api.get<ApiResponseType<GetAllServiceResponse[]>>(
    '/api/web/partners/services'
  );
  return res.data;
};
